export const MOBILE_VIEW_TYPES = {
    MODEL_VIEW: 0,
    TIERS_VIEW: 1,
    VISUALIZATIONS_VIEW: 2,
    LOCALIZATION_VIEW: 3,
    APARTMENT_VIEW: 4,
    FAVORITES_VIEW: 5,
};